import useListOneLogsMutation from './useListOneLogsMutation';
import useListTwoLogsMutation from './useListTwoLogsMutation';

export { useListOneLogsMutation, useListTwoLogsMutation };
